import { Avatar, Card, Collapse, createStyles, IconButton, makeStyles, SvgIconTypeMap, Theme, Typography } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 8,
            overflow: 'hidden',
        },
        header: {
            display: 'flex',
            alignItems: 'flex-start',
            padding: theme.spacing(2, 2.5),
            backgroundColor: '#fafafa',
            cursor: 'pointer',
        },
        headerBody: {
            flex: 1,
            minWidth: 0,
            marginLeft: theme.spacing(2),
        },
        title: {
            fontSize: '0.95rem',
            fontWeight: 600,
        },
        description: {
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.5),
        },
        expandButton: {
            marginLeft: theme.spacing(1),
        },
        content: {
            padding: theme.spacing(3, 2.5),
        },
    }),
);

interface CollapsibleSectionCardProps extends React.PropsWithChildren<{}> {
    title: string;
    description?: string;
    color?: string;
    bgColor?: string;
    icon?: OverridableComponent<SvgIconTypeMap>;
    defaultExpanded?: boolean;
}

export function CollapsibleSectionCard(props: CollapsibleSectionCardProps) {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState(props.defaultExpanded ?? true);

    const toggleExpanded = () => setIsExpanded((prevIsExpanded) => !prevIsExpanded);

    return (
        <Card className={classes.card} elevation={0}>
            <div
                className={classes.header}
                style={{ alignItems: props.description ? 'flex-start' : 'center' }}
                onClick={toggleExpanded}
            >
                {props.icon ? (
                    <Avatar style={{ backgroundColor: props.bgColor ?? '#e0e0e0', color: props.color ?? '#000' }}>
                        <props.icon />
                    </Avatar>
                ) : null}
                <div className={classes.headerBody}>
                    <Typography variant="subtitle1" className={classes.title}>
                        {props.title}
                    </Typography>
                    {props.description && (
                        <Typography variant="body2" className={classes.description}>
                            {props.description}
                        </Typography>
                    )}
                </div>
                <IconButton
                    size="small"
                    className={classes.expandButton}
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleExpanded();
                    }}
                >
                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </div>
            <Collapse in={isExpanded}>
                <div className={classes.content}>
                    {props.children}
                </div>
            </Collapse>
        </Card>
    );
}
